module.exports = __webpack_public_path__ + "img/img_sv_guide_01.aeb5007b.png";